import { JsonProperty } from 'json-typescript-mapper';
import { Image } from './image.model';

export enum SaleStatus {
  NotForSale = 'NotForSale',
  ForSale = 'ForSale',
  Sold = 'Sold'
}

export class Automobilia {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('title')
  public title?: string;

  @JsonProperty('description')
  public description?: string;

  @JsonProperty('titleEn')
  public titleEn?: string;

  @JsonProperty('descriptionEn')
  public descriptionEn?: string;

  @JsonProperty('saleStatus')
  public saleStatus?: SaleStatus;

  @JsonProperty('images')
  public images?: Array<Image>;

  @JsonProperty('price')
  public price?: number;

  constructor(
    id?: number,
    title?: string,
    description?: string,
    saleStatus?: SaleStatus,
    images?: Array<Image>,
    price?: number,
    titleEn?: string,
    descriptionEn?: string
  ) {
    this.id = id ? id : null;
    this.title = title ? title : null;
    this.titleEn = titleEn ? titleEn : null;
    this.saleStatus = saleStatus ? saleStatus : null;
    this.description = description ? description : null;
    this.descriptionEn = descriptionEn ? descriptionEn : null;
    this.images = images ? images : null;
    this.price = price ? price : null;
  }
}
